const parseQuery = (query = '') => {
    let queryToUse = decodeURIComponent(query);

    if (queryToUse[0] === '?') {
        queryToUse = queryToUse.slice(1);
    }
    const parts = queryToUse.split('&');
    const result = {};

    parts.forEach((part) => {
        const members = part.split('=');

        if (members.length >= 2) {
            const key = members[0];
            const value = members[1];

            result[key] = value;
        }
    });
    return result;
};

export default parseQuery;
